import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => {
  return {
    inputBase: {
      flex: 1,
      fontSize: '18px',
      fontWeight: 'bold',
      paddingLeft: '20px'
    },
    uploadingBugReportLoader: {
      height: '250px',
      display: 'grid',
      placeItems: 'center'
    }
  };
});

export default styles;
